import { Component, computed, inject, input } from '@angular/core';
import { SupplierContractCard } from '../supplier-contract-card/supplier-contract-card';
import { SupplierContractCardSkeleton } from '../supplier-contract-card-skeleton/supplier-contract-card-skeleton';
import { SupplierContractPage } from '../../stores/supplier-contracts.store';
import { ErrorPage } from '../../../../shared/components/error-page/error-page';
import { Router } from '@angular/router';
import { InViewportDirective } from '../../../../shared/directives/in-viewport';

@Component({
  selector: 'app-supplier-contracts-grid',
  imports: [SupplierContractCard, SupplierContractCardSkeleton, ErrorPage, InViewportDirective],
  templateUrl: './supplier-contracts-grid.html',
})
export class SupplierContractsGrid {
  protected router = inject(Router);

  supplierContracts = input.required<SupplierContractPage[]>();
  fullPrice = input.required<boolean>();
  currentYear = input.required<number>();
  showLoadMorePlaceholders = input.required<boolean>();
  limit = input.required<number>();

  protected placeholders = computed(() => [...Array(this.limit())]);

  protected error = computed(() => this.supplierContracts().find((c) => c.error));
}
